module.exports = __webpack_public_path__ + "img/invite_friend.214a9c00.png";